import User from './User.model'
import CsvFile from '@/app/models/CsvFile.model'
import Collection from '@/core/classes/Collection'

export default class Users extends Collection {
  model () {
    return User
  }

  /**
   * Generate csv file for download from uploaded csv file
   *
   * @param {Object} csv
   */
  generateCsvFromCreate (csv) {
    return new Promise((resolve) => {
      const usernameKey = csv.headers.find(header => header.field === 'username').value
      let userFromCsv

      const missedCsvKeys = csv.headers
        .filter(header => header.field === null)
        .map(header => header.value)

      const userCollection = new Users(this._models)

      userCollection.loop(userModel => {
        userFromCsv = csv.users
          .find(user => userModel.get('username') === user[usernameKey])

        missedCsvKeys.forEach(missedCsvKey => {
          userModel.set(missedCsvKey, userFromCsv[missedCsvKey], true)
        })
      })

      userCollection.generateCsv([
        ...User.defaultCsvHeaders(),
        ...missedCsvKeys
      ]).then(({ headers, rows }) => {
        let filename = csv.filename.split('.').slice(0, -1).join('.')
        resolve(new CsvFile({ filename: filename, headers, rows }))
      })
    })
  }
}
